<template>
  <div>
    <MainMenu />
    <v-main class="py-0">
      <v-container>
        <v-layout column>
          <v-col cols="7" >
            <h1 class="py-3">Informações do imóvel</h1>
          </v-col>
          <v-layout row wrap justify-space-between>
            <ImmobileDetailCard />
          </v-layout>
        </v-layout>
      </v-container>
    </v-main>
    <v-spacer class="pt-10"></v-spacer>
    <BottomBar />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import MainMenu from '@/components/Global/MainMenu.vue'
import BottomBar from '@/components/Global/BottomBar.vue'
import ImmobileDetailCard from '@/components/Global/ImmobileDetailCard.vue'

export default {
  name: 'ImmobileDetailScreen',

  components: {
    MainMenu,
    BottomBar,
    ImmobileDetailCard, 
  },

  data: () => ({

  }),

  async mounted() {
    this.cleanBuyMenuId()
    this.cleanRentMenuId()
  },

  computed: {
    
  },

  watch: {

  },

  methods: {
    ...mapActions({
      cleanBuyMenuId: 'Immobile/cleanBuyMenuId',
      cleanRentMenuId: 'Immobile/cleanRentMenuId',
    }),

    ...mapGetters({
      
    }),
  },
};
</script>